var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoToastFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#B3261E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7071 7.7071C14.0976 7.31658 14.0976 6.68342 13.7071 6.2929C13.3166 5.90237 12.6834 5.90237 12.2929 6.2929L13.7071 7.7071ZM6.29289 12.2928C5.90236 12.6834 5.90236 13.3165 6.29289 13.7071C6.68342 14.0976 7.31658 14.0976 7.70711 13.7071L6.29289 12.2928ZM12.2929 6.2929L6.29289 12.2928L7.70711 13.7071L13.7071 7.7071L12.2929 6.2929Z",
    fill: "#B3261E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L13.7071 12.2929ZM6.29289 7.70715C5.90236 7.31663 5.90236 6.68347 6.29289 6.29295C6.68342 5.90242 7.31658 5.90242 7.70711 6.29295L6.29289 7.70715ZM12.2929 13.7071L6.29289 7.70715L7.70711 6.29295L13.7071 12.2929L12.2929 13.7071Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoToastFail);
export default __webpack_public_path__ + "static/media/ico-toast-fail.a91f746218cb476a36d46caf44d32a2a.svg";
export { ForwardRef as ReactComponent };